module.exports = __webpack_public_path__ + "img/login-graph.a5cadd66.svg";